/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matches_Empty_RunInputs */

const cs_matches_empty_run = /** @type {(inputs: Matches_Empty_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím nespárováno — spusťte párování.`)
};

const en_matches_empty_run = /** @type {(inputs: Matches_Empty_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not matched yet — run matching.`)
};

/**
* | output |
* | --- |
* | "Not matched yet — run matching." |
*
* @param {Matches_Empty_RunInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const matches_empty_run = /** @type {((inputs?: Matches_Empty_RunInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matches_Empty_RunInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_matches_empty_run(inputs)
	return cs_matches_empty_run(inputs)
});